import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-code-warning-1-circle-icon',
  templateUrl: './code-warning-1-circle.component.html'
})
export class CodeWarning1CircleComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
